import {
  CreateDocumentRecord,
  DocumentRecord,
  UpdateDocumentRecord,
} from '@/models/DocumentRecord';
import { apiClient } from '@/services/api';
import { logger } from '@/utils/logger/loggerInstance';

export const getPropertyDocumentRecords = async (propertyId?: string) => {
  if (!propertyId) {
    return [];
  }

  const url = `/properties/${propertyId}/document-records`;

  logger.debug(`GET ${url}`);
  const response = await apiClient.get<DocumentRecord[]>(url);

  return response.data;
};

export const createDocumentRecord = async ({
  propertyId,
  data,
}: {
  propertyId: string;
  data: CreateDocumentRecord;
}) => {
  const url = '/document-records';

  logger.debug(`POST ${url}`);
  const response = await apiClient.post<DocumentRecord>(url, { ...data, propertyId });

  return response.data;
};

export const updateDocumentRecord = async ({
  id,
  data,
}: {
  id: string;
  data: UpdateDocumentRecord;
}) => {
  const url = `/document-records/${id}`;

  logger.debug(`PUT ${url}`);
  const response = await apiClient.put<DocumentRecord>(url, data);

  return response.data;
};

export const deleteDocumentRecord = async ({ id }: { id: string }) => {
  const url = `/document-records/${id}`;

  logger.debug(`DELETE ${url}`);
  const response = await apiClient.delete<void>(url);

  return response.data;
};

export const generateDocumentRecordUrl = async ({ id }: { id: string }) => {
  const url = `/document-records/${id}/generate-url`;

  logger.debug(`POST ${url}`);
  const response = await apiClient.post<string>(url);

  return response.data;
};
